import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { useContent } from '../context/ContentContext';

const FAQ = () => {
  const { content } = useContent();
  const faqs = content.faqs;
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="bg-[#f6f6f2] py-24 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#0e9f6e] mb-3">FAQ</p>
          <h2 className="font-display text-4xl sm:text-5xl font-700 text-[#0f1712]">Questions, answered.</h2>
        </div>
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={i} className="rounded-2xl bg-white border border-[#0f1712]/8 overflow-hidden">
                <button onClick={() => setOpenIdx(open ? -1 : i)} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left">
                  <span className="font-display text-lg font-600 text-[#0f1712]">{f.q}</span>
                  <span className="shrink-0 text-[#0e9f6e]">{open ? <Minus size={20} /> : <Plus size={20} />}</span>
                </button>
                <div className={`grid transition-all duration-300 ease-in-out ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-[#0f1712]/60 text-[15px] leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
